<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="none">
    <path
      d="M7 11L12 6L17 11M12 18V7"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
